import apiInstance from "../../config/api";

export const getWalletDetails = async () => {
    const response = await apiInstance.get("/api/wallet/details")
    return response.data.data
}

export const getWalletHistory = async (pagination) => {
    const params = {
        page: pagination?.page || 1,
        limit: pagination?.limit || 10,
        startDate: pagination?.startDate,
        endDate: pagination?.endDate
    }
    const response = await apiInstance.get("/api/wallet/transactions", { params })
    return response.data.data
}

export const converWalletCoin = async (coinsToConvert) => {
    const response = await apiInstance.post("/api/wallet/convert", { coinsToConvert })
    return response.data.data
}

export const getTransferOTP = async () => {
    const response = await apiInstance.post("/api/wallet/transfer/send-otp")
    return response.data
}

export const transferCoin = async (payload) => {
    const response = await apiInstance.post("/api/wallet/transfer", payload)
    return response.data.data
}

export const getCoinPackages = async () => {
    const response = await apiInstance.get("/api/payment/coin-packages")
    return response.data.data
}

export const getTransactionReceipt = async (transactionId) => {
    const response = await apiInstance.get(`/api/payment/receipt/${transactionId}`)
    return response.data.data
}

export const reportTransaction = async (transactionId, payload) => {
    const response = await apiInstance.post(`/api/payment/transaction-history/${transactionId}/report`, payload)
    return response.data.data
}